import { read } from "./read"

export const projectSearch = {
  read,
}
